import React from 'react';
import { useLocalizedData } from '../i18n';
import './LocationCard.css';

function LocationCard({ location, selected, onClick }) {
  const { localize } = useLocalizedData();

  return (
    <div
      className={`location-card ${selected ? 'selected' : ''}`}
      onClick={() => onClick(location)}
    >
      <div className="location-emoji">{location.image}</div>
      <h3 className="location-name">{localize(location.name)}</h3>
      <p className="location-desc">{localize(location.description)}</p>
      {selected && <div className="location-check">✓</div>}
    </div>
  );
}

export default LocationCard;
